import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as MuiTooltip } from '@mui/material';
import styles from './styles.module.scss';


const Tooltip = ({ updateState, children, fullWidth, inline, ...other }) => {

  return (
    <MuiTooltip arrow {...other} >
      <div className={`${styles.childWrapper} ${fullWidth ? styles.fullWidth : ''} ${inline ? styles.inline : ''}`}>
        {children}
      </div>
    </MuiTooltip>
  );
};

Tooltip.propTypes = {
  updateState: PropTypes.func,
  children: PropTypes.node
};

export default Tooltip;